import React, { Fragment, useEffect, useState } from "react";
import connect from "react-redux/lib/connect/connect";
import { getAllCount, isEmpty } from "../../../common/cores";
import Locations from "../Locations";
import SportsSearch from "./SportsSearch";

const sportsMenu = [
  {
    name: "soccer",
    kind: "축구",
    gameCount: 0,
    imgPath: "../images/swip/icon_football.png",
    id: 6046,
  },
  {
    name: "hockey",
    kind: "아이스하키",
    gameCount: 0,
    imgPath: "../images/swip/icon_ice_hockey.png",
    id: 35232,
  },
  {
    name: "basketball",
    kind: "농구",
    gameCount: 0,
    imgPath: "../images/swip/icon_basketball.png",
    id: 48242,
  },
  {
    name: "volleyball",
    kind: "배구",
    gameCount: 0,
    imgPath: "../images/swip/icon_volleyball.png",
    id: 154830,
  },
  {
    name: "baseball",
    kind: "야구",
    gameCount: 0,
    imgPath: "../images/swip/icon_baseball.png",
    id: 154914,
  },
  {
    name: "mma",
    kind: "MMA",
    gameCount: 0,
    imgPath: "../images/swip/icon_mma.png",
    id: 154919,
  },
  {
    name: "tabletennis",
    kind: "탁구",
    gameCount: 0,
    id: 265917,
    imgPath: "../images/swip/jongmok_Tabletennis-ico.png",
  },
  {
    name: "football",
    kind: "미식축구",
    id: 131506,
    gameCount: 0,
    imgPath: "../images/swip/rugby-league-ico.png",
  },
  {
    name: "tennis",
    kind: "테니스",
    id: 54094,
    gameCount: 0,
    imgPath: "../images/swip/jongmok_Tennis.png",
  },
  {
    name: "cricket",
    kind: "크리케트",
    id: 452674,
    gameCount: 0,
    imgPath: "../images/swip/jongmok_Baseball.png",
  },
];
const sportsMenuOrigin = [
  {
    name: "soccer",
    kind: "축구",
    gameCount: 0,
    imgPath: "../images/swip/icon_football.png",
    id: 6046,
  },
  {
    name: "hockey",
    kind: "아이스하키",
    gameCount: 0,
    imgPath: "../images/swip/icon_ice_hockey.png",
    id: 35232,
  },
  {
    name: "basketball",
    kind: "농구",
    gameCount: 0,
    imgPath: "../images/swip/icon_basketball.png",
    id: 48242,
  },
  {
    name: "volleyball",
    kind: "배구",
    gameCount: 0,
    imgPath: "../images/swip/icon_volleyball.png",
    id: 154830,
  },
  {
    name: "baseball",
    kind: "야구",
    gameCount: 0,
    imgPath: "../images/swip/icon_baseball.png",
    id: 154914,
  },
  {
    name: "mma",
    kind: "MMA",
    gameCount: 0,
    imgPath: "../images/swip/icon_mma.png",
    id: 154919,
  },
  {
    name: "tabletennis",
    kind: "탁구",
    gameCount: 0,
    id: 265917,
    imgPath: "../images/swip/jongmok_Tabletennis-ico.png",
  },
  {
    name: "football",
    kind: "미식축구",
    id: 131506,
    gameCount: 0,
    imgPath: "../images/swip/rugby-league-ico.png",
  },
  {
    name: "tennis",
    kind: "테니스",
    id: 54094,
    gameCount: 0,
    imgPath: "../images/swip/jongmok_Tennis.png",
  },
  {
    name: "cricket",
    kind: "크리케트",
    id: 452674,
    gameCount: 0,
    imgPath: "../images/swip/jongmok_Baseball.png",
  },
];

const SportsLeague = (props) => {
  const { type, title, view, page, sports } = props;
  let sportslist = [...sportsMenu]; //스포츠종목별로 자료얻기
  let [sportsCnt, setSportsCnt] = useState(sportslist);
  const [active, setActive] = useState("");
  const [itemVal, setItemVal] = useState([]);

  useEffect(() => {
    setActive(page.pageInfo.gameType);
  }, [page.pageInfo.gameType]);

  useEffect(() => {
    let allCount = getAllCount(type); //총경기갯수 시현

    if (isEmpty(allCount) || allCount.count == 0) {
      setSportsCnt(sportsMenuOrigin);
    } else {
      for (let i = 0; i < sportslist.length; i++) {
        allCount.data.forEach((element) => {
          if (element.id == sportslist[i].id) {
            sportslist[i].gameCount = element.count;
            sportslist[i].data = element.data;
          }
        });
      }
      setSportsCnt(sportslist);
    }
  }, [sports.allCount, page.pageInfo.gameType]);

  const onClickItem = (value) => {
    let valdata = itemVal;
    if (valdata.findIndex((item) => item === value) > -1) {
      setItemVal(valdata.filter((item) => item !== value));
      return;
    }
    setItemVal([...valdata, value]);
  };

  return (
    <Fragment>
      <SportsSearch view={props.view} />
      <div className="left_game_tab_box">
        <div className="left_game_tab">
          <ul>
            <li className="active">
              <a>
                {title}
                <span></span>
              </a>
            </li>
            <li className="active">
              <a>
                {isEmpty(window.lang["주요경기"])
                  ? "주요경기"
                  : window.lang["주요경기"]}
                <span></span>
              </a>
            </li>
          </ul>
        </div>
        <div className="left_game_list">
          {!isEmpty(sportsCnt) &&
            sportsCnt.map((item, itemIndex) => {
              // if (isEmpty(item.gameCount) || (item.gameCount === 0)) return "";
              return (
                <Fragment key={itemIndex}>
                  <div
                    className="sports_events_menu"
                    onClick={() => onClickItem(item.id)}
                  >
                    <img src={item.imgPath} className="sports_event_img" />
                    <img
                      src="../images/common/arrow_01.png"
                      className="arrow"
                      alt=""
                    />
                    {isEmpty(window.lang[item.kind])
                      ? item.kind
                      : window.lang[item.kind]}
                    <span className="sports_event_odd">
                      {Number(item.gameCount).toLocaleString()}
                    </span>
                    <span className="sports_event_arrow">
                      <i className="fa-solid fa-angle-down"></i>
                    </span>
                  </div>
                  {itemVal.findIndex((val) => item.id === val) > -1 &&
                    !isEmpty(item.data) &&
                    item.data.map((element, index) => {
                      return (
                        <Locations
                          list={element}
                          Id={element.id.toString()}
                          type={type}
                          sportId={item.id.toString()}
                          key={index}
                          itemVal={itemVal}
                          imgPath={item.imgPath}
                          history={props.history}
                          typeActive={active}
                          view={view}
                        />
                      );
                    })}
                </Fragment>
              );
            })}
        </div>
      </div>
    </Fragment>
  );
};
const mapStateToProps = (state) => ({
  sports: state.sports,
  page: state.page,
});

export default connect(mapStateToProps, {})(SportsLeague);



// WEBPACK FOOTER //
// ./src/components/sports/sportscomponent/SportsLeague.js